module.exports = __webpack_public_path__ + "img/cheque-disabled.6eebdf55.svg";